import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EveeAssistantService } from './evee-assistant.service';

@Component({
  selector: 'app-evee-assistant',
  templateUrl: './evee-assistant.component.html',
  styleUrls: ['./evee-assistant.component.scss']
})
export class EveeAssistantComponent implements OnInit, OnDestroy {
  open = false;
  typedText = '';
  pickerFilter = '';

  @ViewChild('thread', { static: false }) thread: ElementRef;

  constructor(public evee: EveeAssistantService) {}

  ngOnInit() {
    this.evee.bind(() => {
      setTimeout(() => this.scrollThread(), 50);
    });
    const hadPending = !!sessionStorage.getItem('eveePending');
    if (hadPending) {
      this.open = true;
    }
    this.evee.consumePending();
  }

  ngOnDestroy() {
    this.evee.stopListening();
  }

  togglePanel() {
    this.open = !this.open;
    if (this.open) {
      this.evee.messages = [];
      this.evee.greet();
      this.evee.startListening();
    } else {
      this.evee.stopListening();
    }
  }

  sendTyped() {
    const text = (this.typedText || '').trim();
    if (!text) {
      return;
    }
    this.typedText = '';
    this.evee.handleTranscript(text);
  }

  toggleMic() {
    this.evee.startListening();
  }

  pick(user: any) {
    this.evee.pickSubscriber(user);
  }

  filteredSubscribers() {
    if (!this.pickerFilter) {
      return (this.evee.subscriberChoices || []).slice(0, 12);
    }
    return this.evee.filterSubscribers(this.pickerFilter).slice(0, 12);
  }

  suggestionList(): string[] {
    const role = this.evee.getRole();
    if (role === 'admin') {
      return ['Order a report', 'Release a report from QA', 'Switch subscriber', 'Open Quality Assurance', 'Vendor orders'];
    }
    return ['Order a report', 'Open my reports', 'Properties', 'Manage wallet', 'Tenant management'];
  }

  useSuggestion(text: string) {
    this.evee.handleTranscript(text);
  }

  private scrollThread() {
    if (this.thread && this.thread.nativeElement) {
      this.thread.nativeElement.scrollTop = this.thread.nativeElement.scrollHeight;
    }
  }
}
